import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ConsultaFormContainer from "../../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../../components/Container/Container";
import SearchContainer from "../../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../../components/SearchInput/SearchInput";
import { useListManager } from "../../../../contexts/list.manager";
import FormPoliticas from "../FormPoliticas/FormPoliticas";
import ListPoliticas from "../ListPoliticas/ListPoliticas";
import "./ConsultaPoliticas.css";
import { ShieldCheck } from "lucide-react";

const ConsultaPoliticas = () => {
	const { lineSelected } = useListManager();
	const [searchText, setSearchText] = useState("");
	const [filters, setFilters] = useState("");
	const navigate = useNavigate();
	const location = useLocation();
	const [refreshKey, setRefreshKey] = useState(0);

	useEffect(() => {
		if (location.state?.deletedId || location.state?.refresh) {
			setRefreshKey((k) => !k);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<ShieldCheck size={20} />}
					title="Políticas de acesso"
					navigate="../cadastro-politicas"
					description="Buscar por Nome"
					buttonLabel="Adicionar Política"
				>
					<SearchInput
						value={searchText}
						placeholder="Buscar Política"
						onChange={({ target }) => setSearchText(target.value)}
						onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
					/>
				</SearchContainer>
				<Container>
					<ListPoliticas
						filters={filters}
						lineSelected={lineSelected ? true : false}
						refreshKey={refreshKey}
					/>
				</Container>
			</div>
			<ConsultaFormContainer>
				<FormPoliticas politica={lineSelected} type="consulta" />
			</ConsultaFormContainer>
		</div>
	);
};

export default ConsultaPoliticas;
